import { useAppContext } from "../../_context";
import Button from "../Misc/Button";
import ContactWrapper from "../Misc/ContactWrapper";

const ContactSuccess = ({ title, subtitle }) => {
  const [{ tx }] = useAppContext();

  return (
    <ContactWrapper>
      <h1>{title ?? tx["Hooray! Your message has been sent."]}</h1>
      <h4 className="fw-normal mb-4">
        {subtitle ?? tx["We'll get back to you as soon as we can."]}
      </h4>
      <Button href="/" className="mb-4">
        {tx["Back to homepage"]}
      </Button>
    </ContactWrapper>
  );
};

export default ContactSuccess;
